/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

const { Module } = Shopware;

Module.register('dvsn-form-builder', {
    type: 'plugin',
    name: 'dvsn-form-builder.general.name',
    title: 'dvsn-form-builder.general.menu-item-name',
    description: 'dvsn-form-builder.general.menu-item-description',
    color: 'rgb(154, 168, 181)',
    icon: 'regular-cog',

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB
    },
});
